/*
 * WCAG F-2.4.3-a / F-4.1.2-b: Product gallery thumbnail keyboard enhancement.
 *
 * Without this script, every thumbnail anchor is a separate tab stop (42 on the
 * Rainbow PDP, 11 on TAO, etc.), which is technically not a 2.1.2 keyboard trap
 * but feels like one because the container is scrollable and thumbnails have no
 * accessible name. The Liquid snippet now ships with tabindex="0" on the first
 * thumbnail and tabindex="-1" on the rest; this script:
 *   - walks focus through the rail with ArrowUp / ArrowDown / ArrowLeft /
 *     ArrowRight / Home / End (roving tabindex pattern),
 *   - keeps the most recently focused thumbnail as the single tab stop,
 *   - scrolls the focused thumbnail into the scrollable ancestor's visible
 *     area so keyboard users see where focus is,
 *   - activates the thumbnail (click) so the main gallery slides to match.
 *
 * Graceful failure: if this script does not load, the Liquid-side tabindex
 * attributes still collapse the rail to one initial tab stop; users can click
 * thumbnails with a pointer normally.
 */
(function () {
  'use strict';

  var NAV_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

  function getThumbs(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll('.product-medias__thumbnail')
    );
  }

  function setActive(thumbs, target) {
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].setAttribute('tabindex', thumbs[i] === target ? '0' : '-1');
    }
  }

  function onKeyDown(container, event) {
    if (NAV_KEYS.indexOf(event.key) === -1) return;
    var current = document.activeElement;
    if (!current || !current.classList.contains('product-medias__thumbnail')) return;
    if (!container.contains(current)) return;

    var thumbs = getThumbs(container);
    if (thumbs.length < 2) return;

    var currentIdx = thumbs.indexOf(current);
    var targetIdx;
    if (event.key === 'Home') {
      targetIdx = 0;
    } else if (event.key === 'End') {
      targetIdx = thumbs.length - 1;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      targetIdx = (currentIdx - 1 + thumbs.length) % thumbs.length;
    } else {
      targetIdx = (currentIdx + 1) % thumbs.length;
    }

    var target = thumbs[targetIdx];
    event.preventDefault();
    setActive(thumbs, target);
    target.focus();
    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    // Sync the main gallery to the focused thumbnail. The Vue click handler
    // (onMediaActivate) calls slideTo() on the product-medias Swiper.
    target.click();
  }

  function onThumbFocus(container, event) {
    var target = event.target;
    if (!target.classList || !target.classList.contains('product-medias__thumbnail')) return;
    setActive(getThumbs(container), target);
  }

  function init(container) {
    if (container.dataset.wcagGalleryKbd === '1') return;
    container.dataset.wcagGalleryKbd = '1';

    var thumbs = getThumbs(container);
    if (thumbs.length < 2) return;

    // Guarantee roving tabindex state even if Liquid-emitted attributes were
    // stripped by a downstream transform or a late DOM manipulation.
    var hasTabStop = thumbs.some(function (t) {
      return t.getAttribute('tabindex') === '0';
    });
    if (!hasTabStop) {
      setActive(thumbs, thumbs[0]);
    }

    container.addEventListener('keydown', function (e) {
      onKeyDown(container, e);
    });
    container.addEventListener('focusin', function (e) {
      onThumbFocus(container, e);
    });
  }

  function initAll() {
    var containers = document.querySelectorAll('.product-medias__thumbnails');
    for (var i = 0; i < containers.length; i++) {
      init(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify design mode re-renders sections in place; re-init on section load.
  document.addEventListener('shopify:section:load', initAll);
})();
